export const PORTAL_SELECTOR_PATH = '/portals'

export function getUnauthenticatedWelcomeAction(pathname) {
  return pathname === PORTAL_SELECTOR_PATH ? 'login' : 'signup'
}

export function shouldRequirePortalLogin({ pathname, signedIn, authorities }) {
  if (getUnauthenticatedWelcomeAction(pathname) !== 'login') {
    return false
  }

  if (!signedIn) {
    return true
  }

  return !Array.isArray(authorities) || authorities.length === 0
}

export function buildRelativeLocationPath(location) {
  const pathname =
    typeof location?.pathname === 'string' && location.pathname
      ? location.pathname
      : PORTAL_SELECTOR_PATH
  const search = typeof location?.search === 'string' ? location.search : ''
  const hash = typeof location?.hash === 'string' ? location.hash : ''

  return `${pathname}${search}${hash}`
}
